<template>
    <div>
    </div>
</template>


<script>
    export default {
        name: 'admin',
        mounted() {
            window.location.href = process.env.VUE_APP_BACKEND_ADMIN_URL
        }
    }
</script>
